import { Route, Switch } from "react-router-dom";
import AssembleiasListagemPage from "./Listagem";
import AssembleiasDetalhesPage from "./Detalhes";
import DetalheProcuracao from "./Detalhes/components/DetalheProcuracao";

function AssembleiasPages() {
  return (
    <Switch>
      <Route
        exact
        path="/administracao/assembleias"
        component={AssembleiasListagemPage}
      />
      <Route
        path="/administracao/assembleias/criar"
        component={AssembleiasDetalhesPage}
      />
      <Route
        path="/administracao/assembleias/:id"
        component={AssembleiasDetalhesPage}
        exact
      />
      <Route
        path="/administracao/assembleias/:id/procuracoes/:idProcuracao"
        exact
        component={DetalheProcuracao}
      />
    </Switch>
  );
}

export default AssembleiasPages;
